import { compose } from 'ramda';
import { withApollo } from 'react-apollo';
import PermissionsComponent from './PermissionsComponent';

export default compose(withApollo)(PermissionsComponent);
